import React from 'react';
import PropTypes from 'prop-types';
import './StausCell.sass'
import Cell from "../Cell/Cell";

StatusCell.propTypes = {
    text: PropTypes.string.isRequired,
    color: PropTypes.oneOf(['red', 'green', 'orange'])
};

StatusCell.defaultProps = {
    color: 'green',
    text: 'Статус'
}

const palette = {
    red: {color: 'white', background: `rgba(255, 0, 124, 1)`},
    green: {color: 'black', background: `rgba(163, 255, 155, 1)`},
    orange: {color: 'black', background: `#FFCE00`},
    orange2: {color: 'white', background: `#ff7f50`},
    blue: {color: "white", background: `#00b1ff`},
}

function StatusCell({text, color}) {
    return (
        <Cell>
            <div style={palette[color]} className={'statusCell'}>
                {text}
            </div>
        </Cell>
    );
}

export default StatusCell;